import { Card } from "react-bootstrap";
import PieChart from "../charts/PieChart";

function ComunidadMembresíaGrafica({ membresia, title = 'Membresía' }) {
  const data = membresia;
  
  if (!data) {
    return <Card>
    <Card.Header>{title}</Card.Header>
    <Card.Body>
      <p>No hay membresía</p>
    </Card.Body>
  </Card>
  }

  let mData = {
    labels: [],
    datasets: [{
      label: '# de miembros',
      borderWidth: 1,
      data: []
    }]
  };
  data.forEach(item => {
    mData.labels.push(`${item.label}`);
    mData.datasets[0].data.push(item.count || item.members_count);
  });

  return <Card>
    <Card.Header>{title}</Card.Header>
    <Card.Body>
      <PieChart data={mData} />
    </Card.Body>
  </Card>;
}

export default ComunidadMembresíaGrafica;
